const topics = [
    {
        id: 1,
        title: 'Polêmica com incesto!!',
        authorId: 1,
        movieId: 1,
        msg: 'A mãe do Marty ficou de fato interessada nele?? Vi num documentário que foi de propósito, o que acham desse arco da história??',
        likes: 0,
        deslikes: 0,
        comments: [
            {
                authorId: 2,
                msg: 'Acho que foi só uma brincadeira, sem motivos pra se preocupar'
            }
        ]
    },
    {
        id: 2,
        title: 'Pior série que já vi',
        authorId: 2,
        movieId:4,
        msg: 'A protagonista é praticamente uma Jean Grey com anabolizantes, zero noção!! As séries francesas são sempre assim?',
        likes: 0,
        deslikes: 0,
        comments: [],
    },
    {
        id: 3,
        title: 'Meu filho adorou!!',
        authorId: 3,
        movieId: 6,
        msg: 'Coloquei meu filho de 8 anos pra assistir "Procurando Nemo" e ele adorou, não para de falar do filme pros amiguinhos',
        likes: 0,
        deslikes: 0,
        comments: [
            {
                authorId: 1,
                msg: 'Normal, claramente nossa geração teve filmes melhores'
            },
            {
                authorId: 2,
                msg: 'As crianças hoje em dia só querem assistir esses mods de GTA com personagens da Marvel, seu filho é uma exceção'
            },
            {
                authorId: 4,
                msg: 'Que maravilhoso!! Essa é uma história sobre amor fraternal e tudo que um pai/mãe faz pelo seu filho, que bom que passaram esse tempo juntos.'
            }
        ],
    },
    {
        id: 4,
        title: 'A sessão da tarde estava presa no feitiço do tempo?',
        authorId: 4,
        movieId: 7,
        msg: 'É muito irônico um filme que fala sobre repetições e rotinas ser tão repetido na sessão da tarde kkkkk que sacanagem',
        likes: 0,
        deslikes: 3,
        comments: [
            {
                authorId: 1,
                msg: 'Normal, coisa da nossa geração.'
            },
            {
                authorId:2,
                msg: 'E Lagoa azul então?'
            }
        ]
    }
]
export default topics